module.exports = __webpack_public_path__ + "img/5_banner.7f35e789.png";